import PropTypes from 'prop-types';
import SwiperPaginationImpl from './swiper-pagination.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * SwiperPagination component. Renders the clickable dots of a {@link Mojito.Presentation.Components.Swiper|Swiper} component.
 *
 * @class SwiperPagination
 * @memberof Mojito.Presentation.Components
 */

/**
 * SwiperPagination prop types.
 *
 * @property {number} dotCount - Amount of dots to render, one per scroll position of the swiper.
 * @property {number} [activeIndex] - Index of the dot representing the current scroll position.
 * @property {Function} [onSelect = noop] - Callback triggered with the index of the clicked dot.
 *
 * @memberof Mojito.Presentation.Components.SwiperPagination
 */
const propTypes = {
    dotCount: PropTypes.number.isRequired,
    activeIndex: PropTypes.number,
    onSelect: PropTypes.func,
};

const defaultProps = {
    onSelect: noop,
};

export default UIView('SwiperPagination', SwiperPaginationImpl, propTypes, defaultProps);
